import { FormControl, FormGroup, Validators } from "@angular/forms";

export class MakeCallForm extends FormGroup {

  constructor() {

    super({
      announce: new FormControl<string>('', []),
      from: new FormControl<string>('', [Validators.required]),
      record: new FormControl<boolean>(false),
      to: new FormControl<string>('', [Validators.required]),
      via: new FormControl<string>('', [Validators.required]),
    });

  }

}
